<template>
  <div>
    <v-container >
      <CollateralBankList/>
    </v-container>
  </div>
</template>

<script>
import CollateralBankList from '../../../components/Gl/CollateralBank/CollateralBankList.vue';

export default {
  name: 'ReportHeadersTotal',
  components: {
    CollateralBankList,
  },
  data: () => ({
  }),
  created() {
  },
  computed: {
  },
  methods: {
  },
};

</script>
